import React from "react";
const CursoFAQ = (props) => {
  const { pregunta, respuesta } = props;
  return (
    <>
      <h2 className="txtLetrita"> {pregunta}</h2>

      <hr className="txtLetrita" />
      <p> {respuesta}</p>
    </>
  );
};

export default CursoFAQ;
